module.exports = __webpack_public_path__ + "static/media/11.6818f480.JPG";